const relatorioRastreabilidade = [
    {
        path: '/relatorio-rastreabilidade',
        meta: {
            roles: ['ROLE_FEATURE_RELATORIO_RASTREABILIDADE']
        },
        component: () => import('@/views/DefaultRouterView'),
        children: [
            {
                path: '',
                name: 'RelatorioRastreabilidade',
                meta: {
                    roles: ['ROLE_FEATURE_RELATORIO_RASTREABILIDADE']
                },
                component: () =>
                    import(
                        '@/views/relatorioRastreabilidade/GestaoRelatorioRastreabilidade'
                    )
            },
            {
                path: '/relatorio-rastreabilidade/cadastrar',
                name: 'CadastrarRelatorio',
                meta: {
                    roles: ['ROLE_FEATURE_RELATORIO_RASTREABILIDADE']
                },
                component: () =>
                    import('@/views/relatorioRastreabilidade/InserirRelatorio')
            },
            {
                path: '/relatorio-rastreabilidade/editar',
                name: 'EditarRelatorio',
                props: true,
                meta: {
                    roles: ['ROLE_FEATURE_RELATORIO_RASTREABILIDADE']
                },
                component: () =>
                    import('@/views/relatorioRastreabilidade/EditarRelatorio')
            },
            {
                path: '/relatorio-rastreabilidade/visualizar',
                name: 'VisualizarRelatorio',
                props: true,
                meta: {
                    roles: ['ROLE_FEATURE_RELATORIO_RASTREABILIDADE']
                },
                component: () =>
                    import(
                        '@/views/relatorioRastreabilidade/VisualizarRelatorio'
                    )
            }
        ]
    }
];

export default relatorioRastreabilidade;
